import MapboxGL from 'mapbox-gl';

// set mapbox token
MapboxGL.accessToken = process.env.VUE_APP_MAPBOX_TOKEN;

const createMap = config => {
  // init Mapbox
  const map = new MapboxGL.Map({
    ...config,
    interactive: false,
  });

  return map;
};

export default {
  createMap,
};
